import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import {
  MAILING_LIST_PAGE_URL,
  HOME_PAGE_URL,
} from '../../utils/constants/Routes';

// Data
import {
  mailingListPageStructuredData,
  mailingListPageAdditionalMeta,
} from '../../utils/data/MetaData';

// Components
import MailingSignUpPageMainContainer from '../../components/mailing/MailingSignUpPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { mailingListFaqItems } from '../../utils/data/faqSchemas';

function MailingSignUpPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Mailing List', href: MAILING_LIST_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Mailing List'
        desc={`Join ${CompanyName}'s exclusive mailing list to receive session openings, travel announcements, availability updates, Locktober alerts, and VIP information directly from your Muscle Goddess.`}
        keywords={KeywordsPages}
        additionalMeta={mailingListPageAdditionalMeta}
        structuredData={[mailingListPageStructuredData, breadcrumbLd]}
        canonicalPath={MAILING_LIST_PAGE_URL}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24 text-center'>
            <h1
              aria-label={`Join ${CompanyName}'s mailing list`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              Join Queen Blaire’s Mailing List
            </h1>

            <h2 className='tracking-wider mt-1 text-xl xs:text-2xl sm:text-3xl font-bold text-center'>
              Get session openings, tour plans, VIP notices, and major
              announcements straight to your inbox.
            </h2>
          </header>

          {/* Main page content */}
          <MailingSignUpPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={mailingListFaqItems} />
      </div>
    </>
  );
}

export default MailingSignUpPage;
